/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import moment from 'moment';
import { DownloadIcon, SearchIcon } from '../../../../assets/icons';
import { Constants, formatMiles, fromStorage, getUpdatedState } from '../../../../utils';
import { Input, Modal, Pagination, Render } from '../../../../components';
import { MaintenanceService } from '../../../../services';
import ModalSupplies from './modal-supplies';
import ModalEvidence from './modal-evidence';

const MODAL = {
  NONE: 0,
  SUPPLY: 1,
  EVIDENCE: 2,
}

const ReportMaintenance = ({ tabs }) => {
  const [modal, setModal] = useState(MODAL.NONE);
  const [selectedItem, setSelectedItem] = useState(null);
  const { data, filters, goToPage, onChange, downloadAll, pagination, reload, search } = useFetchTable();

  const onSelectItem = (modal, item = null) => {
    setSelectedItem(item);
    setModal(modal);
  };

  return (
    <main className="w-full">
      <Modal isOpen={modal === MODAL.SUPPLY} onClose={() => onSelectItem(MODAL.NONE)}>
        {selectedItem && (
          <ModalSupplies item={selectedItem} onClose={() => onSelectItem(MODAL.NONE)} />
        )}
      </Modal>

      <Modal isOpen={modal === MODAL.EVIDENCE} onClose={() => onSelectItem(MODAL.NONE)}>
        {selectedItem && (
          <ModalEvidence item={selectedItem} onClose={() => onSelectItem(MODAL.NONE)} />
        )}
      </Modal>

      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
        <div className="flex flex-1 flex-wrap items-end gap-3">
          <Input
            className={{ base: 'max-w-60' }}
            placeholder="Buscar placa"
            value={filters.plaque}
            onValueChange={v => onChange('plaque', v)}
            prepend={
              <img src={SearchIcon} className="w-4 h-4" alt="" />
            }
          />

          <Input
            className={{ base: 'max-w-44' }}
            type="date"
            label="Desde"
            value={filters.since}
            onValueChange={v => onChange('since', v)}
          />

          <Input
            className={{ base: 'max-w-44' }}
            type="date"
            label="Hasta"
            value={filters.until}
            onValueChange={v => onChange('until', v)}
          />

          <div className="flex gap-4">
            <button
              className="bg-red hover:bg-red-700 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors"
              onClick={search}
            >
              Filtrar
            </button>
            <button
              className="bg-black hover:bg-gray-800 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors"
              onClick={() => reload()}
            >
              Limpiar
            </button>
          </div>
        </div>
      </div>

      {tabs}

      <div className="bg-white rounded-2xl shadow-md overflow-hidden mt-6">
        <div className="flex items-center justify-between py-4 px-3">
          <p className="text-2xl font-bold text-center">Historial mantenimiento</p>

          <button
            className="flex items-center gap-2 bg-black text-white px-4 py-1.5 rounded-lg font-semibold"
            onClick={() => toast.promise(downloadAll(), { loading: 'Descargando...', success: 'Reporte descargado con éxito', error: 'Error al descargar el reporte' })}
          >
            <img src={DownloadIcon} className="w-4 h-4 brightness-200" alt="" />
            Descargar
          </button>
        </div>

        <div className="overflow-x-auto">
          <table className="text-left border-collapse w-full">
            <thead>
              <tr className="border-b border-gray5 [&>th]:px-1 [&>th]:py-2 [&>th]:break-words [&>th]:max-w-36 text-default font-semibold align-bottom">
                <th><span className="pl-4">Placa vehículo</span></th>
                <th>Categoría</th>
                <th>Subcategoría</th>
                <th>Fecha de mantenimiento</th>
                <th>Kilometraje</th>
                {/* <th>Detalles (Insumos/Repuestos)</th> */}
                {/* <th>Evidencia</th> */}
                {/* <th>Observaciones</th> */}
                <th>Estatus</th>
                {/* <th><p className="pr-3 text-right">Acción</p></th> */}
              </tr>
            </thead>
            <tbody className="text-sm text-text">
              {data.map((item, index) => (
                <tr key={index} className="hover:bg-gray5 transition-colors odd:bg-gray5 [&>td]:py-3 [&>td]:px-1 [&>td]:truncate [&>td]:max-w-36">
                  <td className="text-orange font-bold text-base">
                    <Render condition={!index || item.vehicle_id !== data.at(index - 1)?.vehicle_id}>
                      <span className="pl-4">{ item?.vehicle?.plaque }</span>
                    </Render>
                  </td>
                  <td>{ item?.category?.name }</td>
                  <td>{ item?.subcategory?.name }</td>
                  <td>{ moment(item?.finished_at ?? item?.created_at).format('DD-MM-YY') }</td>
                  <td>{ formatMiles(item?.mileage, false, '').trim() }</td>
                  {/* <td>
                    {item?.status === Constants.MAINTENANCE.STATUS.FINISHED ? (
                      <span
                        className="text-white bg-[#000] rounded-full px-2 py-1 cursor-pointer"
                        onClick={() => onSelectItem(MODAL.SUPPLY, item)}
                      >
                        Ver
                      </span>
                    ) : (
                      <span>--</span>
                    )}
                  </td> */}
                  {/* <td>
                    {item?.status === Constants.MAINTENANCE.STATUS.FINISHED ? (
                      <span
                        className="text-white bg-[#000] rounded-full px-2 py-1 cursor-pointer"
                        onClick={() => onSelectItem(MODAL.EVIDENCE, item)}
                      >
                        Ver
                      </span>
                    ) : (
                      <span>--</span>
                    )}
                  </td> */}
                  {/* <td>{ item?.observations || '--' }</td> */}
                  <td className="text-black font-bold data-[status=0]:text-red data-[status=1]:text-orange" data-status={item?.status}>
                    { item?.status_text }
                  </td>
                  {/* <td align="right">
                    <div className="pr-3">
                      <img
                        src={DownloadIcon}
                        className="w-5 h-5 object-contain cursor-pointer"
                        onClick={() => {
                          toast.promise(
                            downloadOne(item?.id),
                            {
                              loading: 'Descargando...',
                              success: 'Reporte impreso con éxito',
                              error: 'Error al imprimir el reporte',
                            }
                          );
                        }}
                        alt=""
                      />
                    </div>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>

          {!data.length && (
            <p className="py-8 text-text text-center">No se han encontrado registros de mantenimientos</p>
          )}
        </div>

        <div className="px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-4">
          <Pagination
            active={pagination.page}
            pages={pagination.pages}
            onChange={goToPage}
          />
        </div>
      </div>
    </main>
  );
};

const useFetchTable = () => {
  const initialFilters = {
    page: 1,
    perPage: Constants.PER_PAGE,
    search: '',
    plaque: '',
    since: '',
    until: '',
  };

  const initialPagination = {
    page: 1,
    pages: 1,
    total: 0,
    perPage: Constants.PER_PAGE,
  };

  const [data, setData] = useState([]);
  const [canFetch, setCanFetch] = useState(true);
  const [filters, setFilters] = useState(initialFilters);
  const [pagination, setPagination] = useState(initialPagination);

  const fetchData = async () => {
    if (!canFetch) return;
    setCanFetch(false);

    try {
      const payload = await getUpdatedState(setFilters);
      const response = await MaintenanceService.owner.findAll(payload);
      const { data, ...rest } = response;

      setData(data);
      setPagination(rest);
      setCanFetch(true);

    } catch (error) {
      setData([]);
      setCanFetch(true);
    }
  }

  const downloadAll = async () => {
    try {
      const response = await MaintenanceService.owner.downloadAll(filters);
      if (response?.url) {
        const link = document.createElement('a');
        link.href = fromStorage(response.url);
        link.target = '_blank';
        link.download = response.url.split('/').pop();
        document.body.appendChild(link);
        link.click();
        link.remove();
      }

    } catch (error) {
      console.log(error);
    }
  }

  const downloadOne = async (id) => {
    try {
      const response = await MaintenanceService.owner.downloadOne(id);
      if (response?.url) {
        const link = document.createElement('a');
        link.href = fromStorage(response.url);
        link.target = '_blank';
        link.download = response.url.split('/').pop();
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (error) {
      console.log(error);
    }
  }

  const reload = (inSamePage = false) => {
    setCanFetch(true);
    if (!inSamePage) setFilters(initialFilters);
    fetchData();
  }

  const goToPage = async (page) => {
    const pagination = await getUpdatedState(setPagination);
    if (page >= 1 && page <= pagination.pages && page !== pagination.page) {
      setCanFetch(true);
      setFilters({ ...filters, page });
      fetchData();
    }
  }

  const onChange = (target, value) => {
    setFilters(s => ({ ...s, page: 1, [target]: value }));
  }

  useEffect(() => {
    fetchData();
  }, []);

  return {
    data,
    filters,
    goToPage,
    isLoading: !canFetch,
    onChange,
    downloadAll,
    downloadOne,
    pagination,
    reload,
    search: fetchData,
  }
}

export default ReportMaintenance;